export const COST_TYPE_OPTIONS = [
    { label: "Material", value: "DIRECT_MATERIAL" },
    { label: "Conversion", value: "CONVERSION_COST" },
    { label: "Factory Cost Level", value: "TOTAL_COST" },
];

export const VALUE_MODE_OPTIONS = [
    { label: "Percentage", value: "PERCENT" },
    { label: "Crore (₹)", value: "CRORE" },
];

export const formatUnitValue = (value, valueMode) => {
    if (valueMode === "CRORE") {
        return `₹${value.toFixed(2)} Cr`;
    }
    return `${value.toFixed(2)}%`;
};

const COST_TYPE_LABELS = {
    DIRECT_MATERIAL: "Material",
    CONVERSION_COST: "Conversion",
    TOTAL_COST: "Total",
};

export const getCostTypeLabel = (costLevel) => COST_TYPE_LABELS[costLevel] || "Total";

/**
 * Builds the pieces needed for a chart heading that reflects the currently
 * applied filters (cost type / FY / value mode / selected projects / unit),
 * so charts read like "Unit Wise Material Cost - FY 2026-2027 - Percentage -
 * Project: X" instead of a static title.
 *
 * `selectedUnit`/`unitOptions` are optional - only ProjectWiseCostBarChart
 * has a Unit filter, so `unitLabel` comes back undefined for charts that
 * don't pass them.
 */
export const getChartFilterSummary = ({
    costLevel,
    selectedFY,
    valueMode,
    selectedProjectKeys = [],
    projectKeyToProject,
    selectedUnit,
    unitOptions,
}) => {
    const projectNames = selectedProjectKeys
        .map((key) => projectKeyToProject?.get(key)?.PROJ_NAME)
        .filter(Boolean);

    const unitLabel =
        selectedUnit && selectedUnit !== "ALL"
            ? unitOptions?.find((option) => option.value === selectedUnit)?.label
            : undefined;

    return {
        costTypeLabel: getCostTypeLabel(costLevel),
        fyLabel: !selectedFY || selectedFY === "OVERALL" ? "Overall" : selectedFY,
        valueModeLabel: valueMode === "CRORE" ? "Crores (₹)" : "Percentage",
        projectNames,
        unitLabel,
    };
};